module.exports = __webpack_public_path__ + "img/powerGrid-icon_7.2212ce67.png";